import React from 'react'
export default React.createContext({
  tags: [],
  query: '',
  onSetTags: () => {},
  onSetQuery: () => {}
})
